import Roles from "@/utils/roles.js";

export default [
  // ...existing routes...
  
  {
    path: "/fine-tuning-arquivos",
    name: "fine-tuning-arquivos",
    component: () => import("@/views/area-mention/fine-tuning-arquivos/index"),
    meta: {
      title: 'Arquivos Fine-tuning ChatGPT',
      authRequired: true,
      roles: [Roles.GerenciarArquivosFineTuning ]
    },
  },

  {
    path: '/fine-tuning-arquivos/:tipo/:id',
    name: 'FineTuningEditar',
    component: () => import('@/views/area-mention/fine-tuning-arquivos/form.vue'),
    meta: {
      title: 'Editar arquivos Fine-tuning ChatGPT',
      authRequired: true,
      roles: [Roles.GerenciarArquivosFineTuning ]
    }
  },
  
  // ...existing routes...
];
